/**
 * Announcement bar — seamless marquee loop + dismiss.
 * The bar lives in normal flow (not sticky). Speed is px/second; the loop
 * duration is derived from the real group width so the visual speed stays
 * constant regardless of how many messages are present.
 */
(function () {
  var bars = document.querySelectorAll('[data-announcement-bar]');
  if (!bars.length) return;

  bars.forEach(function (bar) {
    var sectionId = bar.getAttribute('data-section-id');
    var storageKey = 'announcement-dismissed-' + sectionId;

    /* Dismissed earlier this session → remove without flashing */
    if (bar.classList.contains('announcement-bar--dismissible')) {
      try {
        if (sessionStorage.getItem(storageKey) === '1') {
          bar.remove();
          document.documentElement.style.setProperty('--announcement-offset', '0px');
          return;
        }
      } catch (e) { /* sessionStorage unavailable — show the bar */ }
    }

    var track = bar.querySelector('[data-announcement-track]');
    var group = bar.querySelector('[data-announcement-group]');
    var viewport = bar.querySelector('.announcement-bar__viewport');
    if (track && group && viewport) {
      var speed = parseFloat(bar.getAttribute('data-speed')) || 60;

      /*
       * Build the loop: repeat the group enough times so that ONE "unit" is at
       * least as wide as the visible viewport, then place two identical units in
       * the track. translateX(0 → -50%) then shifts exactly one unit, which is
       * seamless because the unit fully covers the viewport (no empty gap).
       */
      function buildLoop() {
        /* Reset: keep only the original group */
        var groups = track.querySelectorAll('[data-announcement-group]');
        for (var i = groups.length - 1; i >= 1; i--) {
          groups[i].remove();
        }

        var groupWidth = group.offsetWidth;
        var viewportWidth = viewport.offsetWidth;
        if (groupWidth <= 0) return;

        /* Copies needed for one unit to cover the viewport (capped for safety) */
        var perUnit = Math.max(1, Math.ceil(viewportWidth / groupWidth));
        perUnit = Math.min(perUnit, 50);

        /* Two identical units → total groups = perUnit * 2 (we already have 1) */
        var totalGroups = perUnit * 2;
        var frag = document.createDocumentFragment();
        for (var j = 1; j < totalGroups; j++) {
          var clone = group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          frag.appendChild(clone);
        }
        track.appendChild(frag);

        var unitWidth = groupWidth * perUnit;
        track.style.setProperty('--announcement-duration', (unitWidth / speed).toFixed(2) + 's');
      }

      buildLoop();

      /* Recompute once fonts are loaded (widths change as Urbanist swaps in) */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(buildLoop);
      }

      /* Rebuild on viewport width changes. Observing the viewport (flex:1) is
         safe: appending clones to the track does not change the viewport size,
         so this never re-enters. */
      if (window.ResizeObserver) {
        new ResizeObserver(buildLoop).observe(viewport);
      } else {
        window.addEventListener('resize', buildLoop);
      }
    }

    /* Dismiss button */
    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.remove();
        document.documentElement.style.setProperty('--announcement-offset', '0px');
        try { sessionStorage.setItem(storageKey, '1'); } catch (e) { /* no-op */ }
      });
    }
  });
})();
